import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useStyles } from './style';

interface ExamDetailsProps {
  examYear: number;
  admissionLevel: string;
  examLevel: string;
  mtLanguage: string;
  isAEIS: boolean;
}

const ExamDetails = ({ examDetails }: { examDetails: ExamDetailsProps }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { examYear, admissionLevel, examLevel, mtLanguage, isAEIS } = examDetails;

  return (
    <Box className={`${classes.container} ${classes.documentBadgeContainer}`}>
      <Typography variant="h3" className={classes.subheader}>
        {t('exam->>RegistrationSummary.ExamDetails')}
      </Typography>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('exam->>RegistrationSummary.ExamYear')}
            valueText={examYear.toString()}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue keyText={t('exam->>RegistrationSummary.ExamLevel')} valueText={examLevel} />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('exam->>RegistrationSummary.LevelSeekingAdmission')}
            valueText={admissionLevel}
          />
        </Grid>
      </Grid>
      {isAEIS && (
        <Grid container spacing={2}>
          <Grid md={12} xs={12}>
            <KeyValue
              keyText={t('exam->>RegistrationSummary.MotherTongueLanguageToBeTaken')}
              valueText={mtLanguage}
              capitalize={false}
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ExamDetails;
